import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  NgZone,
  inject,
  signal,
} from '@angular/core';
import { LANDING_GEM } from '../../data';
import { LandingGemFacetsPipe } from '../../pipes';

@Component({
  selector: 'campaign-landing-gem',
  imports: [LandingGemFacetsPipe],
  templateUrl: './landing-gem.component.html',
  styleUrl: './landing-gem.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingGemComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly ngZone = inject(NgZone);

  protected readonly rotation = signal(Math.PI / LANDING_GEM.facets);

  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    let frameId = 0;
    const frame = (time: number): void => {
      this.rotation.set(
        ((time % LANDING_GEM.period) / LANDING_GEM.period) * Math.PI * 2,
      );
      frameId = requestAnimationFrame(frame);
    };

    this.ngZone.runOutsideAngular(() => {
      frameId = requestAnimationFrame(frame);
    });
    this.destroyRef.onDestroy(() => cancelAnimationFrame(frameId));
  }
}
